<template>
  <div>
    <el-row :gutter="10" class="u-mt-10 u-mb-20">
      <el-col :xs="24" :sm="6" :md="6">
        <el-select v-model="anoSelected" placeholder="Ano" @change="load">
          <el-option v-for="a in anosDisponiveis" :key="a" :label="String(a)" :value="a"></el-option>
        </el-select>
      </el-col>
      <el-col :xs="24" :sm="6" :md="6">
        <el-select v-model="mesSelected" placeholder="Mês" @change="load">
          <el-option v-for="m in mesesDisponiveis" :key="m.value" :label="m.label" :value="m.value"></el-option>
        </el-select>
      </el-col>
      <el-col :xs="24" :sm="12" :md="12" class="u-text-right">
        <el-button type="info" plain icon="el-icon-refresh" @click="load">ATUALIZAR</el-button>
      </el-col>
    </el-row>

    <el-row :gutter="10">
      <el-col :xs="24" :sm="6" :md="6">
        <div class="card-dashboard">
          <div class="card-title">Total de rotas</div>
          <div class="card-value">{{ dados.cards.total_rotas || 0 }}</div>
        </div>
      </el-col>
      <el-col :xs="24" :sm="6" :md="6">
        <div class="card-dashboard">
          <div class="card-title">Alunos transportados</div>
          <div class="card-value">{{ dados.cards.alunos_transportados || 0 }}</div>
        </div>
      </el-col>
      <el-col :xs="24" :sm="6" :md="6">
        <div class="card-dashboard">
          <div class="card-title">Veículos ativos</div>
          <div class="card-value">{{ dados.cards.veiculos_ativos || 0 }}</div>
        </div>
      </el-col>
      <el-col :xs="24" :sm="6" :md="6">
        <div class="card-dashboard">
          <div class="card-title">Custo mensal</div>
          <div class="card-value">{{ formatMoney(dados.cards.custo_mensal || 0) }}</div>
        </div>
      </el-col>
    </el-row>

    <el-row :gutter="10" class="u-mt-20">
      <el-col :xs="24" :sm="8" :md="8">
        <div class="card-dashboard">
          <div class="card-title">Custo por aluno</div>
          <div class="card-value">{{ formatMoney(dados.indicadores.custo_por_aluno || 0) }}</div>
        </div>
      </el-col>
      <el-col :xs="24" :sm="8" :md="8">
        <div class="card-dashboard">
          <div class="card-title">Custo por km (estim.)</div>
          <div class="card-value">{{ formatMoney(dados.indicadores.custo_por_km || 0) }}</div>
        </div>
      </el-col>
      <el-col :xs="24" :sm="8" :md="8">
        <div class="card-dashboard">
          <div class="card-title">Consumo médio (km/l)</div>
          <div class="card-value">{{ formatNumber(dados.indicadores.consumo_medio_km_l || 0) }}</div>
        </div>
      </el-col>
    </el-row>

    <el-row :gutter="10" class="u-mt-20">
      <el-col :xs="24" :sm="12" :md="12">
        <c-panel title="Custo do mês (combustível x manutenção)" titleIcon="fas fa-chart-pie">
          <doughnut-chart :chart-data="chartCustos" :height="160"></doughnut-chart>
        </c-panel>
      </el-col>
      <el-col :xs="24" :sm="12" :md="12">
        <c-panel title="Rotas mais longas (km estim.)" titleIcon="fas fa-chart-bar">
          <bar-chart :chart-data="chartRotas" :height="160"></bar-chart>
        </c-panel>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  components: {
    cPanel: () => import('@/shared/c-panel/c-panel.vue'),
    BarChart: () => import('@/chart/BarChart'),
    DoughnutChart: () => import('@/chart/DoughnutChart')
  },
  data: () => ({
    anoSelected: (new Date()).getFullYear(),
    mesSelected: (new Date()).getMonth() + 1,
    anosDisponiveis: [],
    mesesDisponiveis: [
      { value: 1, label: 'JAN' }, { value: 2, label: 'FEV' }, { value: 3, label: 'MAR' },
      { value: 4, label: 'ABR' }, { value: 5, label: 'MAI' }, { value: 6, label: 'JUN' },
      { value: 7, label: 'JUL' }, { value: 8, label: 'AGO' }, { value: 9, label: 'SET' },
      { value: 10, label: 'OUT' }, { value: 11, label: 'NOV' }, { value: 12, label: 'DEZ' }
    ],
    dados: { cards: {}, indicadores: {}, rotas_mais_longas: [] },
    chartCustos: {
      labels: ['Combustível', 'Manutenção'],
      datasets: [{ data: [0, 0], backgroundColor: ['#346daa', '#f5a623'] }]
    },
    chartRotas: {
      labels: [],
      datasets: [{ label: 'KM estimado', data: [], backgroundColor: '#50964d' }]
    }
  }),
  mounted () {
    this.initAnos()
    this.load()
  },
  methods: {
    initAnos () {
      const y = (new Date()).getFullYear()
      this.anosDisponiveis = [y - 2, y - 1, y, y + 1]
    },
    async load () {
      const instituicaoId = this.$store.state.config.instituicao.id
      if (!instituicaoId) return
      const url = `${this.$store.state.config.baseUrlApi}/api/transporte-escolar/dashboard/${instituicaoId}?ano=${this.anoSelected}&mes=${this.mesSelected}`
      const res = await this.$axios.get(url, this.$store.getters.getHeaderAuth)
      this.dados = res.data || { cards: {}, indicadores: {}, rotas_mais_longas: [] }

      const combustivel = Number((this.dados.indicadores && this.dados.indicadores.custo_combustivel) || 0)
      const manut = Number((this.dados.indicadores && this.dados.indicadores.custo_manutencao) || 0)
      this.chartCustos = {
        labels: ['Combustível', 'Manutenção'],
        datasets: [{ data: [combustivel, manut], backgroundColor: ['#346daa', '#f5a623'] }]
      }

      const rotas = this.dados.rotas_mais_longas || []
      this.chartRotas = {
        labels: rotas.map(r => r.nome || ('#' + r.id)),
        datasets: [{ label: 'KM estimado', data: rotas.map(r => Number(r.quilometragem_estimada || 0)), backgroundColor: '#50964d' }]
      }
    },
    formatMoney (value) {
      const v = Number(value || 0)
      return v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
    },
    formatNumber (value) {
      const v = Number(value || 0)
      return v.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    }
  }
}
</script>

<style scoped>
.card-dashboard{
  background: #fff;
  border: 1px solid #e6e6e6;
  border-radius: 6px;
  padding: 14px;
}
.card-title{ font-size: 12px; color: #666; }
.card-value{ font-size: 22px; font-weight: 600; margin-top: 6px; }
</style>

